import { createDict } from '@/util/dicts'

const copy = (d,key) => {
  return d.map(i => ({...i,value:key+'|'+i.value}))
}


var dataCache = null
var lastSubjectId
export default {
  props:{
    value:null,
    force:{
      type: Boolean,
      default: false
    },
    disabled:{
      type: Boolean,
      default:false
    },
    placeholder:{
      type: String,
      default:'请选择'
    },
    //禁用缓存
    nocache:{
      type:Boolean,
      default:false
    },
    //自动选中第一项（如果可用）
    autoSelect:{
      type:Boolean,
      default:false
    }
  },
  data(){
    return {
      raw:[],
      data:[],
      current:[]
    }
  },
  created(){

  },
  methods:{
    handleChange(_, selectedData){
      this.emit(selectedData)
    },

    emit(data , selectedEvent){
      if( data.length == 0 ) return
      if( data.length == 1 ){
        this.$emit('input' , data[0].value)
        this.$emit('change-license' , null)
      }else if( data.length == 2 ){
        let publicValue = data[1].value.split('|').map(i => parseInt(i))
        this.$emit('input' , publicValue[0])
        this.$emit('change-license' , publicValue[1])
      }
     
    },

    formatDisplay(labels , selectedData){
      return labels.join(' ')
    },

    update(insVal){
      if(insVal === undefined || insVal === null){
        this.current = []
      }else{
        this.current[0] = insVal
      }
      
    },

    initData(data){
      data = data.map(i => ({value:i.id , label:i.name}))
      let examState = createDict('examState')
      for(let i of examState){
        i.children = copy(data,i.value)
      }
      
      this.data = examState

      let defaultValue = this.value
      this.update(defaultValue)
    
      this.$watch('value' , function(nv){
        if( this.data && this.data.length > 0){
          this.update(nv)
        }else{
          this.update()
        }
      })

    }
  },
  created(){
    let reqireUpdate = false//this.subjectId != lastSubjectId
    if(this.nocache || !dataCache || reqireUpdate){
      this.$request.licenseAll().then(resp => {
        if (!resp.code) {
          dataCache = resp.data || []
          this.initData(dataCache)
        }
      })
    }else{
      this.initData(dataCache)
    }

  },
  render(){
    let changeOnSelect = !this.force
    return <Cascader trigger="click" change-on-select={true} value={this.current} data={this.data} on-on-change={this.handleChange} placeholder={this.placeholder} render-format={this.formatDisplay} disabled={this.disabled} />
  }
}